const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&family=Cairo:wght@700;800&display=swap" rel="stylesheet">
<style>
  :root{
    --denim:#4A78C9;--denim-hi:#6E9BE0;--denim-lo:#3559A0;--ink:#1E2A4A;
    --stitch:#F4C95D;--tape:#FFD23F;--tape-edge:#E5A100;--coral:#FF6B5E;
    --cream:#FFF4E2;--cream-2:#FFE2BE;--wood:#E7B27C;--wood-2:#D49A60;
  }
  *{box-sizing:border-box;margin:0;padding:0;}
  html,body{width:100%;height:100%;background:#ffffff;}
  body{display:flex;align-items:center;justify-content:center;font-family:'Baloo 2',cursive;}
  .scene{
    position:relative;width:100%;max-width:100%;aspect-ratio:5/4.6;overflow:hidden;
    border:4px solid var(--ink);border-radius:24px;
    background:#ffffff;
    box-shadow:0 16px 0 -2px rgba(30,42,74,.16),0 28px 50px -22px rgba(30,42,74,.5);
  }
  .scene .tableline{position:absolute;left:0;right:0;top:56%;height:3px;background:#ECECEC;}
  .scene svg{position:absolute;inset:0;width:100%;height:100%;}
  .jeans-wrap{transition:transform .8s cubic-bezier(.34,1.4,.5,1),opacity .4s ease;}
  .scene[data-step="0"] .jeans-wrap{transform:translateY(-120px) rotate(-5deg);opacity:0;}
  .scene:not([data-step="0"]) .jeans-wrap{transform:translateY(0) rotate(0);opacity:1;}
  .zip-pull{transition:transform .8s cubic-bezier(.4,0,.2,1);}
  .scene[data-step="0"] .zip-pull,.scene[data-step="1"] .zip-pull{transform:translateY(60px);}
  .scene:not([data-step="0"]):not([data-step="1"]) .zip-pull{transform:translateY(0);}
  .zip-teeth{transition:opacity .5s ease .2s;}
  .scene[data-step="0"] .zip-teeth,.scene[data-step="1"] .zip-teeth{opacity:0;}
  .scene:not([data-step="0"]):not([data-step="1"]) .zip-teeth{opacity:1;}
  .sparkle{opacity:0;transform-box:fill-box;transform-origin:center;}
  .scene[data-step="2"] .sparkle{animation:sparkle 1s ease-out .4s both;}
  @keyframes sparkle{0%{opacity:0;transform:scale(.2)}45%{opacity:1;transform:scale(1.1) rotate(40deg)}100%{opacity:0;transform:scale(.4) rotate(80deg)}}
  .tape-group{opacity:0;transition:opacity .35s ease;}
  .scene[data-step="3"] .tape-group{opacity:1;}
  .tape-bar{transform-box:fill-box;transform-origin:left center;transform:scaleX(0);transition:transform 1s cubic-bezier(.5,1.25,.4,1);}
  .scene[data-step="3"] .tape-bar{transform:scaleX(1);}
  .tape-ticks,.tape-cap{opacity:0;transition:opacity .35s ease .6s;}
  .scene[data-step="3"] .tape-ticks,.scene[data-step="3"] .tape-cap{opacity:1;}
  .waist-label{
    position:absolute;z-index:8;left:50%;top:5%;transform:translateX(-50%) translateY(-14px) scale(.6);
    background:#fff;border:3px solid var(--ink);border-radius:18px;
    padding:7px 18px 8px;text-align:center;white-space:nowrap;
    box-shadow:0 6px 0 -1px rgba(30,42,74,.25);
    opacity:0;transition:opacity .4s ease,transform .55s cubic-bezier(.34,1.6,.5,1);
  }
  .scene[data-step="3"] .waist-label{opacity:1;transform:translateX(-50%) translateY(0) scale(1);transition-delay:.85s;}
  .waist-label .row{display:flex;align-items:center;justify-content:center;gap:12px;line-height:1;}
  .waist-label .en{font-family:'Baloo 2',cursive;font-weight:800;font-size:22px;color:var(--coral);}
  .waist-label .ar{font-family:'Cairo',sans-serif;font-weight:800;font-size:22px;color:var(--denim-lo);direction:rtl;}
  .waist-label .dot{width:6px;height:6px;border-radius:50%;background:var(--stitch);border:1.5px solid var(--ink);}
  .waist-label .reading{margin-top:4px;font-family:'Baloo 2',cursive;font-weight:800;font-size:13px;color:var(--ink);background:var(--tape);border:2px solid var(--ink);border-radius:10px;display:inline-block;padding:1px 10px;}
</style>
</head>
<body>
  <div class="scene" id="scene" data-step="0">
    <div class="tableline"></div>
    <svg viewBox="0 0 400 340" preserveAspectRatio="xMidYMid meet">
      <ellipse class="jeans-wrap" cx="200" cy="300" rx="118" ry="14" fill="rgba(30,42,74,.18)"/>
      <g class="jeans-wrap">
        <path d="M108,140 L292,140 C298,183 300,213 300,250 L300,310 L214,310 L200,200 L186,310 L100,310 L100,250 C100,213 102,183 108,140 Z" fill="var(--denim)" stroke="var(--ink)" stroke-width="5" stroke-linejoin="round"/>
        <path d="M120,160 C116,200 116,260 120,302" fill="none" stroke="var(--denim-hi)" stroke-width="6" stroke-linecap="round" opacity=".5"/>
        <path d="M280,160 C284,200 284,260 280,302" fill="none" stroke="var(--denim-lo)" stroke-width="6" stroke-linecap="round" opacity=".5"/>
        <path d="M200,202 L188,304" fill="none" stroke="var(--stitch)" stroke-width="2.5" stroke-dasharray="5 5"/>
        <path d="M200,202 L212,304" fill="none" stroke="var(--stitch)" stroke-width="2.5" stroke-dasharray="5 5"/>
        <rect x="104" y="136" width="192" height="40" rx="14" fill="var(--denim-lo)" stroke="var(--ink)" stroke-width="5"/>
        <line x1="110" y1="156" x2="290" y2="156" stroke="var(--stitch)" stroke-width="2.5" stroke-dasharray="6 6"/>
        <rect x="126" y="132" width="9" height="14" rx="3" fill="var(--denim-lo)" stroke="var(--ink)" stroke-width="3"/>
        <rect x="265" y="132" width="9" height="14" rx="3" fill="var(--denim-lo)" stroke="var(--ink)" stroke-width="3"/>
        <path d="M120,186 C116,200 118,218 130,226" fill="none" stroke="var(--stitch)" stroke-width="2.5"/>
        <path d="M280,186 C284,200 282,218 270,226" fill="none" stroke="var(--stitch)" stroke-width="2.5"/>
        <g class="zip-teeth">
          <line x1="200" y1="176" x2="200" y2="202" stroke="var(--ink)" stroke-width="6"/>
          <line x1="200" y1="178" x2="200" y2="202" stroke="var(--tape-edge)" stroke-width="2" stroke-dasharray="3 3"/>
        </g>
        <circle cx="200" cy="150" r="8" fill="var(--stitch)" stroke="var(--ink)" stroke-width="3"/>
        <circle cx="200" cy="150" r="2.4" fill="var(--ink)"/>
        <g class="zip-pull"><rect x="194" y="190" width="12" height="14" rx="3" fill="var(--tape)" stroke="var(--ink)" stroke-width="3"/></g>
        <g class="sparkle"><path d="M200,118 l4,9 9,4 -9,4 -4,9 -4,-9 -9,-4 9,-4 z" fill="var(--tape)" stroke="var(--ink)" stroke-width="2"/></g>
        <g class="tape-group">
          <g class="tape-cap">
            <path d="M104,116 l0,38" stroke="var(--coral)" stroke-width="4" stroke-dasharray="4 4"/>
            <path d="M296,116 l0,38" stroke="var(--coral)" stroke-width="4" stroke-dasharray="4 4"/>
          </g>
          <rect class="tape-bar" x="104" y="106" width="192" height="22" rx="6" fill="var(--tape)" stroke="var(--ink)" stroke-width="4"/>
          <g class="tape-ticks" stroke="var(--tape-edge)" stroke-width="2">
            <line x1="124" y1="108" x2="124" y2="120"/><line x1="144" y1="108" x2="144" y2="116"/>
            <line x1="164" y1="108" x2="164" y2="120"/><line x1="184" y1="108" x2="184" y2="116"/>
            <line x1="204" y1="108" x2="204" y2="120"/><line x1="224" y1="108" x2="224" y2="116"/>
            <line x1="244" y1="108" x2="244" y2="120"/><line x1="264" y1="108" x2="264" y2="116"/>
            <line x1="284" y1="108" x2="284" y2="120"/>
          </g>
        </g>
      </g>
    </svg>
    <div class="waist-label">
      <div class="row">
        <span class="en">Waist</span>
        <span class="dot"></span>
        <span class="ar">الخصر</span>
      </div>
      <div class="reading">40 cm</div>
    </div>
  </div>
<script>
  const durs=[600,1500,1500,3200];
  const scene=document.getElementById('scene');
  const total=durs.reduce((a,b)=>a+b,0)+700;
  let startT=0;
  function stepFromElapsed(ms){let acc=0;for(let i=0;i<durs.length;i++){acc+=durs[i];if(ms<acc)return i;}return durs.length-1;}
  function tick(ts){
    if(!startT)startT=ts;
    const el=ts-startT;
    scene.setAttribute('data-step',stepFromElapsed(el));
    if(el>=total){startT=0;scene.setAttribute('data-step',0);}
    requestAnimationFrame(tick);
  }
  window.addEventListener('load',()=>setTimeout(()=>requestAnimationFrame(tick),300));
</script>
</body>
</html>`;

const JeansSizeAnimation = () => (
  <div className="flex justify-center">
    <iframe
      srcDoc={html}
      title="Jeans size guide animation"
      className="border-0 rounded-sm w-full"
      style={{ aspectRatio: '5 / 4.6', maxWidth: '220px' }}
      scrolling="no"
    />
  </div>
);

export default JeansSizeAnimation;
